<template>
  <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ author.id"
       aria-expanded="false" :aria-controls="'collapse-'+ author.id" :style="cssProps">
    <table class="" style="width: 100%">
      <tr :class="{selected: author.selected}">
        <td class="col-md-2 col-xs-2 expertColor" style="vertical-align: middle" id="expert">
          {{ author.lastname }}, {{ author.firstname }}
        </td>

        <td class="col-md-3 col-xs-3 " style="vertical-align: middle" id="country-affiliation">
          <table class="table expertColor" style="width: 100%;">
            <td class="col-xs-4 col-md-4 text-center" style="vertical-align: middle">
              <flag v-if="author.company && author.company.id" :squared="false" :iso="getIso(author.company)"
                    style="height: 100%"/>
            </td>
            <td class="col-xs-8 col-md-8" v-if="author.company && author.company.id" style="">{{author.company.name |
              truncate(50)}}
            </td>
          </table>
        </td>

        <td class="col-md-4 col-xs-4 expertColor" id="top-document-title" style="">Self-registered expert on <b>{{query}}</b></td>

        <td class="col-md-1 col-xs-1 text-center" id="expert-score" style="vertical-align: center">
          <select :id="'score-'+ author.id">
            <option value="3">3</option>
            <option value="2">2</option>
            <option value="1">1</option>
          </select>
        </td>
        <td class="col-md-1 col-xs-1 text-center" style="vertical-align: middle; font-size: 17px;">
          <!-- <i v-if="author.followSearchId !== null" class="fas fa-star text-info"></i> -->
          <span data-toggle="popover"
                data-content="Expert having declared him/herself competent on your query and available for contact"
                class="text-info"> &#9424; </span>

        </td>
        <td class="col-md-1 col-sm-1 text-center " style="vertical-align: center" id="expert-action">
          <div v-if="$user.isBasic()" class="dropdown dropdown-author-action">
            <button class="btn-outline btn btn-xs btn-info dropdown-toggle" :id="'dropdownMenu-'+author.id"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :class="{active: author.selected}">Contact ...
            </button>
            <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right" >
                <li>
                  <a role="button" @click="dropDownClick('addAuthor', $event)" title="Subscribe to advanced Account">
                    <i class="fa fa-user-plus text-info"></i> Add expert <i class="fa fa-lock font-bold"></i>
                  </a>
                </li>
                <li class="expert-list-action-li-search"><a role="button" @click="dropDownClick('search', $event)"><i class="fa fa-search text-info"></i> Search expert</a></li>
            </ul>
          </div>
        </td>
      </tr>
    </table>
    <div style="bottom: -9px;position: absolute;width: 100%">
      <span style="margin-left: 49%;background-color: white;">
        <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
        <i class="fa fa-chevron-down"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<style>
  .top-document {
    cursor: pointer;
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }
  .br-theme-bars-horizontal .br-widget a {
    height: 10px;
    background-color: rgba(0, 123, 225, 0.3);
  }
</style>

<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import 'jquery-bar-rating/dist/themes/bars-horizontal.css'
import {convertHex} from '../../assets/scripts/utils'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {},
  name: 'LocalAuthorTop',
  props: ['value', 'context'],
  data () {
    return {
      author: null,
      expertColor: '#6a6c6f',
      ratingColor: '#007bff',
      query: null
    }
  },
  watch: {
    value: function (val) {
      this.author = val
    },
    author: function (val, oldVal) {
      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  computed: {
    cssProps () {
      return {
        '--expert-color': '#' + this.expertColor,
        '--rating-color': convertHex('#' + this.ratingColor, 0.3)
      }
    }
  },
  methods: {
    initScore: (author) => {
      let scoreElement = $('#score-' + author.id)

      scoreElement.barrating({
        theme: 'bars-horizontal',
        readonly: true,
        showSelectedRating: false,
        hoverState: false,
        reverse: true,
        initialRating: 0.1
      })
    },
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined' && affiliation.country) {
        let iso = IsoCountries.getAlpha2Code(affiliation.country.name, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.country.code)
        }
        return iso
      }
    },
    dropDownClick: function (action, event) {
      event.preventDefault()
      let basicPlan = this.$user.isBasic()

      switch (action) {
        case 'addAuthor':
          if (basicPlan === false) {
            this.author.selected = true
          }
          this.$emit('input', Object.assign({}, this.author))
          this.context.addAuthor(this.author, 'author')
          break
        case 'search':
          let author = {firstName: this.author.firstname, lastName: this.author.lastname}
          this.context.searchAuthorByName(author, 'author')
          break
      }

      $('#dropdownMenu-' + this.author.id).dropdown('toggle')

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    }
  },
  updated () {
    this.initScore(this.author)
  },
  mounted () {
    this.initScore(this.author)
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: 'body',
      html: true
    })
  },
  beforeMount () {
    this.author = this.value
    this.expertColor = this.$auth.user().profile.color_expert
    this.ratingColor = this.expertColor
    let query = this.$route.params.query
    this.query = decodeURIComponent(query).replace(',', ' ')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/LocalAuthorTop.vue